
import Styles from './WallpapersContainer.module.scss';
import HomeAndLockScreen from '../../home-and-lock-screen/HomeAndLockScreen';
import { useContext, useState } from 'react';
import { ToastContext } from '../../../../../contexts/toast/ToastContextProvider';
import { APP_KEY_IDS } from '../../../../../constants/constants';
import { getDateTimeFromTimestamp } from '../../../../../global/functions/functrions';

interface WallpapersContainerProps {
    wallpapers: any;
}

const WallpapersContainer = ({ wallpapers }: WallpapersContainerProps) => {


    const [wallLink, setWallLink] = useState("")

    const removeLink = () =>{
        setWallLink("")
    }

    const onClickDone = (type:string) => {
        document.documentElement.style.setProperty((`--mobile-${type}-image`), "url(" + wallLink + ") no-repeat");
    }

    return (
        <div className={Styles.container}>
            {
                Object.keys(wallpapers).map((type: string) => {
                    return (
                        <div className={Styles.wallpapers_container} key={type}>
                            <div className={Styles.label}>{wallpapers[type].label}</div>
                            <div className={Styles.flex_images}>
                                {
                                    wallpapers[type].options.map((image: string, index: number) => {
                                        return (
                                            <img src={image} key={index + "_" + image} onClick={() => { setWallLink(image) }} />
                                        )
                                    })
                                }
                            </div>
                        </div>
                    )
                })
            }

            {wallLink &&
                <FullScreenWallpaper
                    wallpaperLink={wallLink}
                    onClickCancel={removeLink}
                    onClickDone={onClickDone}
                />}
        </div>
    )
}

export default WallpapersContainer


interface FullScreenWallpaperProps {
    wallpaperLink: string;
    onClickCancel: () => void;
    onClickDone: (type:string) => void;
}

const FullScreenWallpaper = ({
    wallpaperLink,
    onClickCancel,
    onClickDone,
}: FullScreenWallpaperProps) => {

    const {showToast} = useContext(ToastContext)

    const handleDone=(type:string)=>{
        onClickDone(type)
        showToast({
            [`settings_${Date.now()}`]: {
                appId: APP_KEY_IDS.SETTINGS,
                appName: "Settings",
                bannerImage: "",
                mobileAppId: APP_KEY_IDS.MOBILE_SETTINGS,
                subText: `${type} wallpaper has been changes`,
                time: getDateTimeFromTimestamp(Date.now()),
                title: "Hiring Offer",
                visitLink: ""
            }
        })
    }

    return (
        <div className={Styles.full_page} >
            <img className={Styles.blurred_bg} src={wallpaperLink} />
            <div className={Styles.flex_container}>
                <div className={Styles.demo}>
                    <HomeAndLockScreen 
                        customContainerClass={Styles.demo_container} 
                        wallpaperLink={wallpaperLink} 
                        isCheckingWallpapers={true}
                        onClickDone={handleDone}
                        onClickWallpapers={onClickCancel}
                        />
                </div>
            </div>
            <div className={Styles.help_text}>
                Scroll to toggle between home and lock screen
            </div>
        </div>
    )
}
